import { WebPage, WithContext } from 'schema-dts';

import { DEFAULT_STRUCTURE } from '../constants';
import type { ArticleMapperResult } from './article';
import type { OrganizationMapperResult } from './organization';

export type WebPageMapperParams = {
  name: string;
  description: string;
  url: string;
  datePublished: string;
  dateModified: string;
  publisher: OrganizationMapperResult;
  mainEntity: ArticleMapperResult;
};

export const webPageMapper = ({
  name,
  description,
  url,
  datePublished,
  dateModified,
  publisher,
  mainEntity,
}: WebPageMapperParams): WithContext<WebPage> => ({
  ...DEFAULT_STRUCTURE,
  '@type': 'WebPage',
  name,
  description,
  url,
  datePublished,
  dateModified,
  publisher,
  mainEntity,
});
